import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { b2bSideCopy, type ListingSide } from '../../b2bSideCopy';

const SIDES: ListingSide[] = ['SEEKING', 'OFFERING'];

// [MCV-1889] DD15: the side is chosen before the wizard opens, so there is no side toggle inside it.
export const NewListingMenu = ({
  onSelect,
  buttonTag,
}: {
  onSelect: (side: ListingSide) => void;
  buttonTag: string;
}) => (
  <Menu as="div" className="relative inline-block text-left">
    <MenuButton
      data-cy={buttonTag}
      className="flex items-center gap-2 rounded-lg border border-primary-t-700 px-3.5 py-2 body-text-sb text-primary-50 transition-colors hover:border-primary-t-600 hover:bg-primary-t-900 cursor-pointer"
    >
      <PlusCircleIcon className="size-5" aria-hidden="true" />
      Create New Listing
      <ChevronDownIcon className="size-4" aria-hidden="true" />
    </MenuButton>
    <MenuItems
      modal={false}
      anchor="bottom end"
      className="z-50 w-[300px] rounded-lg border border-grey-900 bg-white py-2 shadow-lg"
    >
      {SIDES.map((side) => (
        <MenuItem key={side}>
          <button
            type="button"
            data-cy={`new-listing-${side === 'OFFERING' ? 'selling' : 'buying'}`}
            className="block w-[calc(100%-12px)] mx-1.5 cursor-pointer rounded-md px-2.5 py-2 text-left text-sm text-grey-200 data-[focus]:bg-grey-900/50"
            onClick={() => onSelect(side)}
          >
            {b2bSideCopy(side).newListingMenuLabel}
          </button>
        </MenuItem>
      ))}
    </MenuItems>
  </Menu>
);
